var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "nav",
        { staticClass: "nav-account" },
        _vm._l(_vm.filteredTabs, function(tab) {
          return _c(
            "a",
            {
              key: tab,
              class:
                _vm.currentTab == tab
                  ? "nav-account__item active"
                  : "nav-account__item",
              on: {
                click: function($event) {
                  return _vm.changeTab(tab)
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t(`admins.tabs.${tab}`)) + " ")]
          )
        }),
        0
      ),
      _vm.currentTab === "edit" && _vm.selectedAdmin
        ? _c("AdminEditForm", {
            attrs: { action: "edit" },
            on: { save: _vm.save }
          })
        : _vm.currentTab === "notifications"
        ? _c("AdminNotifications")
        : _vm.currentTab === "groups"
        ? _c("AdminGroups")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }